export default class EditCtrl {
    constructor($scope, httpRequest, $stateParams, $state) {
        if (!$stateParams.contractId) {
            $state.go('input.electronImage.contractEntering.list')
        }
        // 从合同管理详情页面跳转过来定位到具体tab
        const { tabIndex } = $stateParams
        // 控制每个tab页的显示 默认全部显示
        let tabIndexList = [true, true, true]
        const titles = ['封面影像', '合同影像', '发票信息']
        // 有tabindex参数则只显示对应tab
        if (tabIndex) {
            tabIndexList = [false, false, false]
            tabIndexList[tabIndex] = true
            setTimeout(() => {
                $('.breadcrumb').find('li:last-child').find('a').text(titles[tabIndex])
            })
        }
        $scope.tabIndex = Number(tabIndex) || 0
        $scope.tabIndexList = tabIndexList
        // 路由参数invoiceId 表示此页面只编辑这一张发票
        const { invoiceId } = $stateParams
        // 路由参数readonly不显示影像编辑功能
        $scope.readonly = $stateParams.readonly === 'readonly'
        // 统计数据 该单据共有影像页、OCR识别发票AA页，其中增值税专用发票BB张，增值税普通发票CC张
        $scope.statisticInfo = {}
        function updateStatistic(contract) {
            let specialCount = 0
            let normalCount = 0
            const invoiceCount = contract.contractInvoiceList.length

            contract.contractInvoiceList.forEach((invoice) => {
                if (invoice.invoiceType === '0') {
                    specialCount += 1
                }
                if (invoice.invoiceType === '2') {
                    normalCount += 1
                }
            })
            return {
                total: 1 + contract.contractFileList.length + invoiceCount,
                invoiceCount,
                specialCount,
                normalCount,
            }
        }
        function init() {
            httpRequest.get_getContractEntryDetail($stateParams.contractId).then((res) => {
                const contract = res.data.value
                $scope.contract = contract
                const editAbleInvoiceList = []
                contract.contractInvoiceList.forEach((invoice) => {
                    // 路由参数invoiceId 表示此页面只编辑这一张发票
                    if (invoiceId && invoice.invoiceId === invoiceId) {
                        editAbleInvoiceList.push(invoice)
                    }
                })
                if (invoiceId) {
                    contract.contractInvoiceList = editAbleInvoiceList
                }
                $scope.statisticInfo = updateStatistic(contract)
            })
            // 删除发票或者合同影像后统计数据改变
            $scope.$on('contractStatisticChange', () => {
                $scope.statisticInfo = updateStatistic($scope.contract)
            })
        }
        init()
    }
}
EditCtrl.$inject = ['$scope', 'httpRequest', '$stateParams', '$state']



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/editCtrl.js